module.exports = __webpack_public_path__ + "static/media/Program_Detail.FileCount.893c821c.svg";